import { render, staticRenderFns } from "./EinstellungenLohn.vue?vue&type=template&id=76e9e127&"
import script from "./EinstellungenLohn.vue?vue&type=script&lang=js&"
export * from "./EinstellungenLohn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports